<ix-modal-header [requiredRoles]="requiredRoles" [title]="title" [loading]="isFormLoading"></ix-modal-header>

<mat-card>
  <mat-card-content>
    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-fieldset [title]="'General Options' | translate">
        <ix-input
          formControlName="destination"
          [label]="'Destination' | translate"
          [required]="true"
          [tooltip]="tooltips.destination"
        ></ix-input>

        <ix-input
          formControlName="gateway"
          [label]="'Gateway' | translate"
          [required]="true"
          [tooltip]="tooltips.gateway"
        ></ix-input>

        <ix-input
          formControlName="description"
          [label]="'Description' | translate"
          [tooltip]="tooltips.description"
        ></ix-input>
      </ix-fieldset>

      <ix-form-actions>
        <button
          *ixRequiresRoles="requiredRoles"
          mat-button
          type="submit"
          color="primary"
          ixTest="save"
          [disabled]="form.invalid || isFormLoading"
        >
          {{ 'Save' | translate }}
        </button>
      </ix-form-actions>
    </form>
  </mat-card-content>
</mat-card>
